import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Import the autoTable plugin
import logo from "../Components/Assets/buillogo6.png";
import { showErrorToast, showSuccessToast } from "../utils/toaster";


export const generatePDF = (products) => {
  const placeholderImage = "/placeholder.png";

  let productImages = [];

  try {
    productImages = products.map((product) => {
      if (
        product.image &&
        typeof product.image === "string" &&
        product.image.startsWith("data:image")
      ) {
        return product.image;
      } else {
        return placeholderImage;
      }
    });
  } catch (error) {
    console.error(error);
    showErrorToast("Error preparing product images.");
    return;
  }

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.width;

  // Add logo
  const logoWidth = 50;
  const logoHeight = 20;
  doc.addImage(logo, "PNG", 10, 10, logoWidth, logoHeight);

  // Add title
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Exciting Product Showdown!", pageWidth / 2, 20, { align: "center" });

  // --- Prepare table data ---
  const headers = ["Attribute", ...products.map((product) => product.name)];
  const rows = [
    ["Name", ...products.map((p) => p.name)],
    ["Description", ...products.map((p) => p.description)],
    ["Price", ...products.map((p) => `Rs.${p.price}`)],
    ["Size", ...products.map((p) => p.size)],
    ["Category", ...products.map((p) => p.category)],
    ["Subcategory", ...products.map((p) => p.subcategory)],
    [
      "Seller",
      ...products.map((p) => {
        if (!p.seller) return "Not Available";
        if (typeof p.seller === "string") return "Seller ID";
        if (typeof p.seller === "object") return p.seller.name || "Unnamed Seller";
        return "Not Available";
      }),
    ],
    ["Total Ratings", ...products.map((p) => p.totalratings)],
    [
      "Specifications",
      ...products.map((p) =>
        p.specifications.length
          ? p.specifications.map((spec) => `${spec.key}: ${spec.value}`).join("\n")
          : "Not Available"
      ),
    ],
  ];

  const imageYPosition = 40;
  const imageHeight = 25;
  const tableStartY = imageYPosition + imageHeight + 10;
  const columnPositions = [];

  // Draw table and track column positions
  doc.autoTable({
    head: [headers],
    body: rows,
    startY: tableStartY,
    theme: "grid",
    margin: { top: 10, left: 10, right: 10 },
    styles: {
      overflow: "linebreak",
      halign: "left",
      fontSize: 9,
    },
    tableWidth: "auto",
    columnStyles: headers.reduce((acc, _, index) => {
      acc[index] = { cellWidth: "auto" };
      return acc;
    }, {}),
    didDrawCell: function (data) {
      // Capture column position from the first header row
      if (data.section === "head" && data.row.index === 0) {
        columnPositions[data.column.index] = {
          x: data.cell.x,
          width: data.cell.width,
        };
      }
    },
    didDrawPage: function () {
      // Align each product image to its respective column (skipping "Attribute" column)
      for (let i = 1; i < headers.length; i++) {
        const { x, width } = columnPositions[i];
        const imgX = x + (width - imageHeight) / 2;
        const productIndex = i - 1;

        if (productImages[productIndex]) {
          doc.addImage(
            productImages[productIndex],
            "JPEG",
            imgX,
            imageYPosition,
            imageHeight,
            imageHeight
          );
        }
      }
    },
  });

  doc.save("product_comparison.pdf");
};

// export const generatePDF = (products) => {
//   const placeholderImage = "/placeholder.png";

//   let productImages = [];

//   try {
//     productImages = products.map((product) => {
//       if (product.image && typeof product.image === "string" && product.image.startsWith("data:image")) {
//         return product.image;
//       } else {
//         return placeholderImage;
//       }
//     });
//   } catch (error) {
//     console.error(error);
//     showErrorToast("Error preparing product images.");
//     return;
//   }

//   const doc = new jsPDF({
//     orientation: "landscape",
//     unit: "mm",
//     format: "a4",
//   });

//   const pageWidth = doc.internal.pageSize.width;

//   // Add logo
//   const logoWidth = 50;
//   const logoHeight = 20;
//   doc.addImage(logo, "PNG", 10, 10, logoWidth, logoHeight);

//   // Add title
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(16);
//   doc.text("Exciting Product Showdown!", pageWidth / 2, 20, { align: "center" });

//   // Image placement settings
//   let imageYPosition = 40;
//   let imageWidth = 25;
//   let spacing = 10;

// // ✅ Dynamically calculate total width of all images + spacing
// const totalImagesWidth = products.length * imageWidth + (products.length - 1) * spacing;

// // ✅ Dynamically calculate start X position to center images
// const startX = (pageWidth - totalImagesWidth) / 2;

// products.forEach((product, index) => {
//   const xPos = startX + index * (imageWidth + spacing); // ✅ Now starting centered
//   doc.addImage(
//     productImages[index],
//     "JPEG",
//     xPos,
//     imageYPosition,
//     imageWidth,
//     imageWidth
//   );
// });


//   // After images, calculate where table should start
//   const tableStartY = imageYPosition + imageWidth + 20;

//   // Table headers
//   const headers = ["Attribute", ...products.map((product) => product.name)];

//   // Table rows
//   const rows = [
//     ["Name", ...products.map((product) => product.name)],
//     ["Description", ...products.map((product) => product.description)],
//     ["Price", ...products.map((product) => `Rs.${product.price}`)],
//     ["Size", ...products.map((product) => product.size)],
//     ["Category", ...products.map((product) => product.category)],
//     ["Subcategory", ...products.map((product) => product.subcategory)],
//     [
//       "Seller",
//       ...products.map((product) => {
//         if (!product.seller) return "Not Available";
//         if (typeof product.seller === "string") return "Seller ID";
//         if (typeof product.seller === "object") return product.seller.name || "Unnamed Seller";
//         return "Not Available";
//       }),
//     ],
//     ["Total Ratings", ...products.map((product) => product.totalratings)],
//     [
//       "Specifications",
//       ...products.map((product) =>
//         product.specifications.length
//           ? product.specifications.map((spec) => `${spec.key}: ${spec.value}`).join("\n")
//           : "Not Available"
//       ),
//     ],
//   ];

//   // Column Styles
//   const columnStyles = {};
//   headers.forEach((_, index) => {
//     columnStyles[index] = { cellWidth: "auto" };
//   });

//   // Draw the table
//   doc.autoTable({
//     startY: tableStartY,
//     head: [headers],
//     body: rows,
//     theme: "grid",
//     styles: {
//       overflow: "linebreak",
//       halign: "left",
//       fontSize: 9, // Slightly smaller font size to fit better
//     },
//     margin: { top: 10, left: 10, right: 10 },
//     tableWidth: "auto",
//     columnStyles,
//   });

//   doc.save("product_comparison.pdf");
// };













// import { jsPDF } from "jspdf";
// import "jspdf-autotable"; // Import the autoTable plugin
// import logo from "../Components/Assets/buillogo6.png";
// import { showErrorToast, showSuccessToast } from "../utils/toaster";

// export const generatePDF = (products) => {
//   const placeholderImage = "/placeholder.png";
// //   // const toBase64 = (url) =>
// //   //   new Promise((resolve, reject) => {
// //   //     const img = new Image();
// //   //     img.crossOrigin = "Anonymous"; // Enable CORS if the image is hosted externally
// //   //     img.onload = () => {
// //   //       const canvas = document.createElement("canvas");
// //   //       canvas.width = img.width;
// //   //       canvas.height = img.height;
// //   //       const ctx = canvas.getContext("2d");
// //   //       ctx.drawImage(img, 0, 0);
// //   //       resolve(canvas.toDataURL("image/jpeg"));
// //   //     };
// //   //     img.onerror = reject;
// //   //     img.src = url;
// //   //   });
// //   //   console.log("Images to convert:", products.map((p) => p.image)); // <-- ADD THIS LINE

// //   // Dynamically load product images based on the products array length
// //   // Promise.all(products.map((product) => toBase64(product.image)))
// //   //   .then((productImages) => {
// //   //     const doc = new jsPDF({
// //   //       orientation: "landscape", // Switch to landscape
// //   //       unit: "mm",
// //   //       format: "a4", // A4 size
// //   //     });

// //   // Convert product images to base64

// //   // const toBase64 = (url) =>
// //   //   new Promise((resolve, reject) => {
// //   //     if (url.startsWith("data:image")) {
// //   //       return resolve(url); // ✅ Already base64 — skip further processing
// //   //     }

// //   //     const img = new Image();
// //   //     img.onload = () => {
// //   //       const canvas = document.createElement("canvas");
// //   //       canvas.width = img.width;
// //   //       canvas.height = img.height;
// //   //       const ctx = canvas.getContext("2d");
// //   //       ctx.drawImage(img, 0, 0);
// //   //       resolve(canvas.toDataURL("image/jpeg"));
// //   //     };
// //   //     img.onerror = () => reject("Failed to load image");
// //   //     img.src = url;
// //   //   });

// //   // console.log("Images to convert:", products.map((p) => p.image));

//   let productImages = [];

//   try {
//     productImages = products.map((product) => {
//       if (
//         product.image &&
//         typeof product.image === "string" &&
//         product.image.startsWith("data:image")
//       ) {
//         return product.image;
//       } else {
//         return placeholderImage;
//       }
//     });
//   } catch (error) {
//     console.error(error);
//     showErrorToast("Error preparing product images.");
//     return;
//   }

// //   // ✅ Start PDF logic directly here — not in a .then()
//   const doc = new jsPDF({
//     orientation: "landscape",
//     unit: "mm",
//     format: "a4",
//   });

//   doc.addImage(logo, "PNG", 10, 10, 50, 20);

// //   // ... rest of your PDF code ...
// //   //doc.save("product_comparison.pdf"); // ✅ No .then() closing here

//       const pageWidth = doc.internal.pageSize.width;

// //       // Add logo to the PDF
//       const logoWidth = 50; // Adjust the logo width
//       const logoHeight = 20; // Adjust the logo height
//       doc.addImage(logo, "PNG", 10, 10, logoWidth, logoHeight);

// //       // Title
//       doc.setFont("helvetica", "bold");
//       doc.setFontSize(16);
//       doc.text("Exciting Product Showdown!", pageWidth / 2, 20, {
//         align: "center",
//       });

//       let imageYPosition = 40;
//       let imageWidth = 40;
//       let spacing = 85;
//       let xPos = 110;
//       let addspace = 60;
//       let cellWidth = 70;
//       // Adjust positioning based on number of products
//       if (products.length === 4) {
//         spacing = 15; // Smaller spacing between images
//         cellWidth = 53;
//       } else if (products.length === 3) {
//         spacing = 35; // Medium spacing for 3 products
//         cellWidth = 70;
//       } else if (products.length === 2) {
//         xPos = 70; // Adjust starting X position for 2 products
//         spacing = 85; // Larger spacing for 2 products
//         cellWidth = 105;
//       } else if (products.length === 1) {
//         cellWidth = "auto";
//         xPos = 110; // Position for 1 product
//         spacing = 85; // Larger spacing for 1 product
//       }

// //       // Add images dynamically based on number of products
//       products.forEach((product, index) => {
//         xPos = addspace + index * (imageWidth + spacing); // Dynamically calculate X position
//         doc.addImage(
//           productImages[index],
//           "JPEG",
//           xPos,
//           imageYPosition,
//           imageWidth,
//           imageWidth
//         );
//       });

// //       // Table headers
//       const headers = ["Attribute", ...products.map((product) => product.name)];

//       // Table rows
//       const rows = [
//         ["Name", ...products.map((product) => product.name)],
//         ["Description", ...products.map((product) => product.description)],
//         ["Price", ...products.map((product) => `Rs.${product.price}`)],
//         ["Size", ...products.map((product) => product.size)],
//         ["Category", ...products.map((product) => product.category)],
//         ["Subcategory", ...products.map((product) => product.subcategory)],
//         ["Seller", ...products.map((product) => {
//           if (!product.seller) return "Not Available";
//           if (typeof product.seller === "string") return "Seller ID"; // fallback
//           if (typeof product.seller === "object") return product.seller.name || "Unnamed Seller";
//           return "Not Available";
//         })],

//         ["Total Ratings", ...products.map((product) => product.totalratings)],
//         [
//           "Specifications",
//           ...products.map((product) =>
//             product.specifications.length
//               ? product.specifications
//                   .map((spec) => `${spec.key}: ${spec.value}`)
//                   .join("\n") // Each specification in a new line
//               : "Not Available"
//           ),
//         ],
//       ];

//       // Define column width styles
//       const columnStyles = {};
//       columnStyles[0] = { cellWidth: "auto" }; // First column (Attribute) will be dynamic
//       // For the remaining columns, set a fixed width
//       for (let i = 1; i < headers.length; i++) {
//         columnStyles[i] = { cellWidth: cellWidth }; // Fixed width for other columns
//       }

// //       // Draw table and center it
//       doc.autoTable({
//         startY: imageYPosition + 50,
//         head: [headers],
//         body: rows,
//         theme: "grid",
//         styles: { overflow: "linebreak", halign: "left" },
//         margin: {
//           top: 30,
//           left: (pageWidth - 240) / 2,
//           right: (pageWidth - 240) / 2,
//         }, // Centered table
//         tableWidth: "auto",
//         columnStyles, // Apply the dynamic and fixed column widths
//       });

//       // Save PDF
//       doc.save("product_comparison.pdf");
//     }
